import type { AttendeesWithInfosType } from 'Store/booking/booking.selector';
import 'Store/booking/booking.selector';
export const SET_CUSTOMER_SEARCH_RESULT = 'SET_CUSTOMER_SEARCH_RESULT';
export const UNSET_CUSTOMER_SEARCH_RESULT = 'UNSET_CUSTOMER_SEARCH_RESULT';
export type CustomerSearchResultState = {
  error?: Error;
  data?: AttendeesWithInfosType;
  searchedHouseholdIndex?: number;
};
const initialState = {};
export const customerSearch = (
  state: CustomerSearchResultState = initialState,
  action: Action<{}>,
) => {
  switch (action.type) {
    case SET_CUSTOMER_SEARCH_RESULT:
      return action.payload;

    case UNSET_CUSTOMER_SEARCH_RESULT:
      return initialState;

    default:
      return state;
  }
};
